import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useDispatch, useSelector } from 'react-redux';
import CONSTANTS from '../util/constants';
import TruckModalComp from './TruckModalComp';
import Encrypt from './../util/encrypt';
import DeleteModalComponent from './DeleteModalCompo';

const TruckComp = () => {

    const gridRef = useRef();


    const dispatch = useDispatch();
    const rowData = useSelector((state) => state.truck.getTruckData);
    const userRoles = useSelector((state) => state.login.loginRolesData);
    const divisionSelectedTemp = useSelector((state) => state.division.divisionSelected);
    const [modalShow, isModalShow] = useState(false);
    const [cellData, setCellClickData] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [columnDefs, setColumnDef] = useState([]);
    const [rowDataTruck, setRowDataTruck] = useState([]);
    const [loginResponse, setLoginResponse] = useState(null);
    const [isShowModalCancel, setIsShowModalCancel] = useState(false);

    useEffect(() => {
        let localstorageLR = localStorage.getItem("L_R");
        if (localstorageLR) {
            let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
            let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';
            setLoginResponse(loginResponse);
        }
        setCellClickData(null);
        dispatch({
            type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_MANAGEMENT_API_CALL
        })
    }, []);

    useEffect(() => {
        if (rowData && rowData?.length > 0 && rowData != 'Failed') {
            let activeTruckData = rowData.filter((item) => item.is_active == true);
            let filterData = activeTruckData?.filter((item) => {
                return (divisionSelectedTemp?.value == item.division_id)
            })
            setRowDataTruck(filterData);
        }
    }, [rowData])


    const cellImageRender = (params) => {
        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)) ?

                <div onClick={() => {
                    setCellClickData(params?.data);
                    showModal(true);
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/actions.png')} />
                </div>
                : null
        );
    };

    const cellCancelImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)) ?

                <div onClick={() => {
                    setCellClickData(params?.data);
                    setIsShowModalCancel(true);
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/cancel.png')} />
                </div>
                : null
        );
    };

    useEffect(() => {

        setColumnDef([
            {
                headerName: 'Truck No',
                field: 'bt_id', filter: true
            },
            {
                headerName: 'Truck Type',
                field: 'type', filter: true
            },
            {
                headerName:
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)) ?
                        'Actions' : '', children: [
                            {
                                field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellImageRender
                            },
                            {
                                field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellCancelImageRender
                            }
                        ]
            },

        ])

    }, [loginResponse])

    const defaultColDef = useMemo(() => ({
        sortable: true
    }));

    const cellClickedListener = useCallback(event => {

    }, []);

    const showModal = (isShow) => {
        isModalShow(isShow);
    }

    const showModalCancel = (isShow) => {
        setIsShowModalCancel(isShow);
    }

    return (

        <div className='row'>

            {modalShow ? <TruckModalComp
                title={cellData != null ? 'Edit Truck' : 'Add New Truck'}
                show={showModal}
                handleClose={showModal}
                isShow={showModal}
                rowDataUser={cellData}
                is_active={isActive}
                setValue={(value) => {
                    isModalShow(false);
                    if (cellData != null) {
                        setCellClickData(null)
                        dispatch({
                            type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_MANAGEMENT_API_CALL, payload: { value: value }
                        })
                    }
                    else {

                        dispatch({
                            type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_MANAGEMENT_API_CALL, payload: { value: value }
                        })

                    }
                }}
            /> : null}

            {isShowModalCancel ? <DeleteModalComponent
                title={'Delete Truck?'}
                show={showModalCancel}
                handleClose={false}
                isShow={showModalCancel}
                truckManagement={true}
                data={cellData}
                setValue={(value) => {
                    setIsShowModalCancel(false);
                    if (cellData != null) {
                        setCellClickData(null)
                        dispatch({
                            type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_MANAGEMENT_API_CALL, payload: { value: value }
                        })
                    }

                }}
            /> : null}
            <div className='col-md-12 col-sm-12 col-12'>

                {
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)) ?
                        < div onClick={() => {
                            isModalShow(true);
                            setCellClickData(null)
                        }} className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', margin: '2px 0 2px 0px' }}>
                            <img src={require('./../assets/Dashboard/plus.png')} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}></img>
                        </div>
                        : null
                }

                <div className="col-md-12 col-sm-12 row-10 ag-theme-alpine" style={{
                    height: '80vh', width: '80vw', margin: 'auto'
                }}>

                    {rowDataTruck && rowDataTruck?.length > 0 ?
                        <AgGridReact
                            ref={gridRef}
                            suppressColumnVirtualisation={true}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                            rowSelection='multiple'
                            onCellClicked={cellClickedListener}
                            rowData={rowDataTruck}
                            columnDefs={columnDefs}>
                        </AgGridReact>
                        : <label>{'No data available'}</label>
                    }
                </div>
            </div>
        </div >
    );
};

export default TruckComp;

